import { errorServiceFactory } from "../services/ErrorServiceImpl";

const errorService = errorServiceFactory();

export async function get(url: string, disableLoadingState = false) {
    if (!disableLoadingState) {
        errorService.setLoadingSubjectState();
    }
    try {
        const response = await fetch(url, {
            method: "GET",
            credentials: "include",
        });
        errorService.handleResponseError(response);
        return response.json();
    } catch (e) {
        errorService.resetErrorResponseSubject();
        throw e;
    }
}

const defaultHeaders = { "Content-type": "application/json" };
export async function patch(
    url: string,
    data?: any,
    method: string = "PATCH",
    headers: HeadersInit = defaultHeaders,
    stringify = true
) {
    errorService.setLoadingSubjectState();
    try {
        const response = await fetch(url, {
            method,
            credentials: "include",
            headers,
            body: stringify ? JSON.stringify(data) : data,
        });
        errorService.handleResponseError(response);
        return response.json();
    } catch (e) {
        errorService.resetErrorResponseSubject();
        throw e;
    }
}

export async function post(
    url: string,
    data: any,
    headers?: HeadersInit,
    stringify = true
) {
    return patch(url, data, "POST", headers, stringify);
}

export async function deleteRequest(url: string, data?: any) {
    return patch(url, data, "DELETE");
}
